// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button_wrapper_2egOR","large":"button_large_2p8Xo","green":"button_green_EEj7z","black":"button_black_2efMn"};